import { nodeApi } from "@/redux/api/nodeApi";
import { TResponseRedux, TUser } from "@/types/types";

export type TQueryParam = {
  name: string;
  value: boolean | React.Key;
};

const userApi = nodeApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get user
    getMe: builder.query({
      query: (args) => {
        return {
          url: `/user/get-me?email=${encodeURIComponent(args)}`,
          method: "GET",
        };
      },
      providesTags: ["User"],
      transformResponse: (res: TResponseRedux<TUser>, meta) => {
        return {
          data: res.data,
          error: res.error,
        };
      },
    }),

    // Update user
    updateUser: builder.mutation({
      query: ({ email, body }: { email: string; body: Partial<TUser> }) => {
        const fullUrl = `/user/update-user?email=${email}`;
        console.log("Full URL:", fullUrl);

        return {
          url: fullUrl,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["User"],
    }),

    // Update creator profile info
    updateCreator: builder.mutation({
      query: ({ id, body }) => ({
        url: `/creator/update-creator-by-creator/${id}`,
        method: "PUT",
        body: body,
      }),
      invalidatesTags: ["User"],
    }),

    // Get creator status
    getCreatorStatus: builder.query({
      query: (email: string) => {
        return {
          url: `/creator-status/get-creator-status?email=${encodeURIComponent(
            email
          )}`,
          method: "GET",
        };
      },
    }),

    removeUser: builder.mutation({
      query: (email: string) => ({
        url: `/user/remove-user-from-db?email=${email}`,
        method: "POST",
      }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const {
  useGetMeQuery,
  useUpdateUserMutation,
  useUpdateCreatorMutation,
  useGetCreatorStatusQuery,
  useLazyGetCreatorStatusQuery,
  useRemoveUserMutation,
} = userApi;
